/** Text explaining that creating or joining a league follows the competition's official channels. */
export const officialChannelsFollowMessage = (action: 'create' | 'join', channelsCount: number) => {
  const intro = action === 'create' ? 'Al crear' : 'Al unirse a';
  const channels =
    channelsCount === 1 ? 'al canal oficial' : 'a los canales oficiales';
  return `${intro} una liga para esta competición, empezarás a seguir ${channels} de esta competición`;
};
